module.exports = __webpack_public_path__ + "static/media/157755464821593074.b1af074e.gif";